import {makeAutoObservable, reaction, runInAction} from "mobx";
import {ApiResult, UserLoginRequest, UserLoginResult, UserProfileResult} from "@mpsinvoices/modelsclient/src";
import AuthenticationApi from "../api/authentication-api";
import {history} from "../../index";

const jwtKey = "jwt";
const refreshTokenKey = "refreshToken";

export class AuthenticationStore {
    token: string | null = window.localStorage.getItem(jwtKey);
    refreshToken: string | null = window.localStorage.getItem(refreshTokenKey);
    userAccount: UserProfileResult | null = null;
    
    constructor() {
        makeAutoObservable(this);

        reaction(
            () => this.token,
            token => {
                if (token) {
                    window.localStorage.setItem(jwtKey, token);
                } else {
                    window.localStorage.removeItem(jwtKey);
                }
            }
        );

        reaction(
            () => this.refreshToken,
            refreshToken => {
                if (refreshToken) {
                    window.localStorage.setItem(refreshTokenKey, refreshToken);
                } else {
                    window.localStorage.removeItem(refreshTokenKey);
                }
            }
        );
    }

    get isLoggedIn() {
        return !!this.userAccount;
    }

    setToken = (token: string | null) => {
        this.token = token;
    }

    setRefreshToken = (refreshToken: string | null) => {
        this.refreshToken = refreshToken;
    }


    login = async (model: UserLoginRequest) => {
        try {
            const loginResult: ApiResult<UserLoginResult> = await AuthenticationApi.login(model);
            runInAction(() => {
                this.setToken(loginResult.model?.jwtToken ?? null);
                this.setRefreshToken(loginResult.model?.refreshToken ?? null);
                this.userAccount = loginResult.model?.userProfile ?? null;
                history.push("/");
            });
        } catch (error) {
            throw error;
        }
    }

    logout = async () => {
        try {
            await AuthenticationApi.logout();
        } catch (error){
            console.log(error);
        }

        runInAction(() => {
            this.setToken(null);
            this.setRefreshToken(null);
            this.userAccount = null;
        });
        history.push("/");
    }

    refreshLogin = async () => {
        try {
            const refreshResult: ApiResult<UserLoginResult> = await AuthenticationApi.refreshToken();
            runInAction(() => {
                this.setToken(refreshResult.model?.jwtToken ?? null);
                this.setRefreshToken(refreshResult.model?.refreshToken ?? null);
                this.userAccount = refreshResult.model?.userProfile ?? null;
                //history.push("/");
            });
        } catch (error){
            console.log(error);
        }
    }
    
    get userInitials() {
        if(!this.userAccount) return null;
        const matches = this.userAccount.fullName.match(/\b(\w)/g);
        
        if(!matches) return null
        return matches.join("").toUpperCase();
    }
}